import React, { useState, useEffect } from "react";
import "./GridCommandStructured.scss";

/**
 * Grid Command Structured - Clean design with proper content organization
 */
const GridCommandStructured: React.FC = () => {
    const [selectedGame, setSelectedGame] = useState<string>("all");
    const [searchQuery, setSearchQuery] = useState("");
    const [showGameSelector, setShowGameSelector] = useState(false);
    const [leaderboardView, setLeaderboardView] = useState<"guild" | "guilds" | "overall">("guild");

    // Mock game data
    const games = [
        { id: "valorant", name: "Valorant", icon: "🎯", status: "online" },
        { id: "fortnite", name: "Fortnite", icon: "🏗️", status: "online" },
        { id: "apex", name: "Apex Legends", icon: "⚡", status: "offline" },
        { id: "cod", name: "Call of Duty", icon: "🔫", status: "online" },
        { id: "overwatch", name: "Overwatch 2", icon: "🛡️", status: "offline" },
    ];

    return (
        <div className="grid-command-structured">
            {/* Background gradient */}
            <div className="background-gradient" />

            {/* Top Navbar */}
            <nav className="top-navbar">
                <div className="navbar-left">
                    <div className="level-display">
                        <span className="level-icon">⭐</span>
                        <span className="level-number">42</span>
                    </div>

                    <div className="xp-progress">
                        <span className="xp-label">XP TO NEXT</span>
                        <div className="xp-bar">
                            <div className="xp-fill" style={{width: "67%"}}>
                                <div className="xp-glow" />
                            </div>
                        </div>
                        <span className="xp-value">2,104</span>
                    </div>

                    <div className="game-status">
                        <span className="status-icon">🎮</span>
                        <span className="status-game">Valorant</span>
                        <span className="status-dot status-dot--online" />
                    </div>
                </div>

                <div className="navbar-center">
                    <div className="reward-status">
                        <span className="reward-icon">🎁</span>
                        <span className="reward-text">Last Reward: 500 FUEL</span>
                        <span className="reward-time">2h ago</span>
                    </div>

                    <div className="multiplier-status">
                        <span className="multiplier-icon">⚡</span>
                        <span className="multiplier-text">2X MULTIPLIER</span>
                        <span className="multiplier-timer">23:45:12</span>
                    </div>
                </div>

                <div className="navbar-right">
                    <button className="nav-icon nav-icon--ideas">
                        <span>💡</span>
                        <div className="icon-tooltip">Ideas & Feedback</div>
                    </button>
                    <button className="nav-icon nav-icon--help">
                        <span>❓</span>
                        <div className="icon-tooltip">Help Center</div>
                    </button>
                    <button className="nav-icon nav-icon--profile">
                        <div className="profile-avatar">
                            <img src="https://via.placeholder.com/40" alt="Profile" />
                            <div className="avatar-status" />
                        </div>
                    </button>
                </div>
            </nav>

            {/* Main Grid Layout */}
            <div className="command-grid">

                {/* LEFT: Guild & Leaderboards */}
                <div className="panel panel--guild">
                    {/* Month Sponsor */}
                    <div className="month-sponsor">
                        <span className="sponsor-label">NOVEMBER POWERED BY</span>
                        <div className="sponsor-brand">
                            <span className="brand-icon">🥤</span>
                            <span className="brand-name">MONSTER ENERGY</span>
                        </div>
                    </div>

                    {/* Guild Header */}
                    <div className="guild-header">
                        <div className="guild-rank-badge">
                            <span className="rank-icon">⚔️</span>
                            <span className="rank-number">#7</span>
                        </div>
                        <div className="guild-info">
                            <div className="guild-avatar">
                                <img src="https://via.placeholder.com/60" alt="Guild" />
                            </div>
                            <div className="guild-details">
                                <h3 className="guild-name">APEX PREDATORS</h3>
                                <span className="my-rank">Your Rank: <strong>#12</strong></span>
                            </div>
                        </div>
                    </div>

                    {/* Leaderboards */}
                    <div className="leaderboards-section">
                        <div className="leaderboard-tabs">
                            <button
                                className={`tab ${leaderboardView === "guild" ? "active" : ""}`}
                                onClick={() => setLeaderboardView("guild")}
                            >
                                GUILD
                            </button>
                            <button
                                className={`tab ${leaderboardView === "guilds" ? "active" : ""}`}
                                onClick={() => setLeaderboardView("guilds")}
                            >
                                GUILDS
                            </button>
                            <button
                                className={`tab ${leaderboardView === "overall" ? "active" : ""}`}
                                onClick={() => setLeaderboardView("overall")}
                            >
                                OVERALL
                            </button>
                        </div>

                        <div className="leaderboard-content">
                            {leaderboardView === "guild" &&
                <div className="leaderboard-list">
                    <div className="leader-item leader-item--first">
                        <span className="rank">1</span>
                        <span className="name">xXSniperXx</span>
                        <span className="score">15,234 XP</span>
                    </div>
                    <div className="leader-item leader-item--second">
                        <span className="rank">2</span>
                        <span className="name">ProGamer42</span>
                        <span className="score">14,876 XP</span>
                    </div>
                    <div className="leader-item leader-item--third">
                        <span className="rank">3</span>
                        <span className="name">DeadEye</span>
                        <span className="score">14,102 XP</span>
                    </div>
                    <div className="leader-separator" />
                    <div className="leader-item leader-item--you">
                        <span className="rank">12</span>
                        <span className="name">You</span>
                        <span className="score">8,896 XP</span>
                    </div>
                </div>
                            }
                            {leaderboardView === "guilds" &&
                <div className="leaderboard-list">
                    <div className="leader-item">
                        <span className="rank">1</span>
                        <span className="name">FAZE CLAN</span>
                        <span className="score">892K GP</span>
                    </div>
                    <div className="leader-item">
                        <span className="rank">2</span>
                        <span className="name">100 THIEVES</span>
                        <span className="score">847K GP</span>
                    </div>
                    <div className="leader-item leader-item--you">
                        <span className="rank">7</span>
                        <span className="name">APEX PREDATORS</span>
                        <span className="score">523K GP</span>
                    </div>
                </div>
                            }
                            {leaderboardView === "overall" &&
                <div className="leaderboard-list">
                    <div className="leader-item">
                        <span className="rank">1</span>
                        <span className="name">Ninja</span>
                        <span className="score">2.3M XP</span>
                    </div>
                    <div className="leader-item">
                        <span className="rank">2</span>
                        <span className="name">Shroud</span>
                        <span className="score">2.1M XP</span>
                    </div>
                    <div className="leader-item">
                        <span className="rank">3</span>
                        <span className="name">Summit1G</span>
                        <span className="score">1.9M XP</span>
                    </div>
                </div>
                            }
                        </div>
                    </div>

                    {/* Guild Quests */}
                    <div className="guild-quests">
                        <h4 className="section-title">GUILD QUESTS</h4>
                        <div className="quest-card quest-card--guild">
                            <div className="quest-header">
                                <span className="quest-icon">🏰</span>
                                <span className="quest-title">FORTRESS DEFENSE</span>
                            </div>
                            <p className="quest-desc">Defend the guild fortress for 15 waves</p>
                            <div className="quest-progress">
                                <div className="progress-bar">
                                    <div className="progress-fill" style={{width: "60%"}}>
                                        <div className="progress-glow" />
                                    </div>
                                </div>
                                <span className="progress-text">9/15 waves</span>
                            </div>
                            <div className="quest-participants">
                                <span className="participant-icon">👥</span>
                                <span className="participant-text">12/20 members joined</span>
                            </div>
                        </div>
                    </div>

                    {/* Daily Guild War */}
                    <div className="guild-war">
                        <h4 className="section-title">DAILY GUILD WAR</h4>
                        <div className="war-card">
                            <div className="war-matchup">
                                <div className="team team--yours">
                                    <span className="team-name">APEX PREDATORS</span>
                                    <span className="team-score">12,450</span>
                                </div>
                                <div className="versus">VS</div>
                                <div className="team team--opponent">
                                    <span className="team-name">DARK KNIGHTS</span>
                                    <span className="team-score">11,200</span>
                                </div>
                            </div>
                            <div className="war-timer">
                                <span className="timer-icon">⏱️</span>
                                <span className="timer-text">ENDS IN 4H 32M</span>
                            </div>
                            <button className="war-action">JOIN BATTLE</button>
                        </div>
                    </div>
                </div>

                {/* MIDDLE: Game Selector & Quests */}
                <div className="panel panel--quests">
                    {/* Enhanced Game Selector */}
                    <div className="game-selector-enhanced">
                        <div className="selector-header">
                            <button
                                className={`filter-btn ${selectedGame === "all" ? "active" : ""}`}
                                onClick={() => setSelectedGame("all")}
                            >
                                <span className="filter-icon">🎮</span>
                                <span className="filter-label">ALL GAMES</span>
                            </button>

                            <div className="search-container">
                                <input
                                    type="text"
                                    placeholder="Search quests, games, rewards..."
                                    className="search-input"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                <span className="search-icon">🔍</span>
                            </div>
                        </div>

                        {/* Quick Game Pills */}
                        <div className="game-pills">
                            {games.map(game =>
                                <button
                                    key={game.id}
                                    className={`game-pill ${selectedGame === game.id ? "active" : ""}`}
                                    onClick={() => setSelectedGame(game.id)}
                                >
                                    <span className="pill-icon">{game.icon}</span>
                                    <span className="pill-name">{game.name}</span>
                                    {game.status === "online" && <span className="pill-status" />}
                                </button>)}
                        </div>
                    </div>

                    {/* Quest Tabs */}
                    <div className="quest-tabs">
                        <button className="quest-tab quest-tab--active">
                            <span className="tab-label">QUESTS</span>
                            <span className="tab-count">12</span>
                        </button>
                        <button className="quest-tab">
                            <span className="tab-label">MISSIONS</span>
                            <span className="tab-count">5</span>
                        </button>
                        <button className="quest-tab">
                            <span className="tab-label">JOURNEY</span>
                            <span className="tab-count">3</span>
                        </button>
                        <button className="quest-tab">
                            <span className="tab-label">POP-UPS</span>
                            <span className="tab-count">2</span>
                            <span className="tab-indicator" />
                        </button>
                    </div>

                    {/* Quest List */}
                    <div className="quest-list">
                        {/* Daily Quests */}
                        <div className="quest-category">
                            <h4 className="category-title">DAILY QUESTS</h4>
                            <div className="quest-card">
                                <div className="quest-game">
                                    <span className="game-icon">🎯</span>
                                    <span className="game-name">Valorant</span>
                                </div>
                                <h5 className="quest-title">FIRST BLOOD</h5>
                                <p className="quest-desc">Get the first kill in 3 matches</p>
                                <div className="quest-progress">
                                    <div className="progress-bar">
                                        <div className="progress-fill" style={{width: "33%"}}>
                                            <div className="progress-glow" />
                                        </div>
                                    </div>
                                    <span className="progress-text">1/3</span>
                                </div>
                                <div className="quest-rewards">
                                    <span className="reward">250 XP</span>
                                    <span className="reward">50 FUEL</span>
                                </div>
                            </div>

                            <div className="quest-card">
                                <div className="quest-game">
                                    <span className="game-icon">🏗️</span>
                                    <span className="game-name">Fortnite</span>
                                </div>
                                <h5 className="quest-title">BUILDER PRO</h5>
                                <p className="quest-desc">Build 500 structures</p>
                                <div className="quest-progress">
                                    <div className="progress-bar">
                                        <div className="progress-fill" style={{width: "80%"}}>
                                            <div className="progress-glow" />
                                        </div>
                                    </div>
                                    <span className="progress-text">400/500</span>
                                </div>
                                <div className="quest-rewards">
                                    <span className="reward">500 XP</span>
                                </div>
                            </div>
                        </div>

                        {/* Journey Quests */}
                        <div className="quest-category">
                            <h4 className="category-title">JOURNEY QUESTS</h4>
                            <div className="quest-card quest-card--journey">
                                <div className="journey-badge">
                                    <span className="badge-icon">🗺️</span>
                                    <span className="badge-text">CHAPTER 3</span>
                                </div>
                                <h5 className="quest-title">ROAD TO LEGEND</h5>
                                <p className="quest-desc">Complete all Chapter 3 objectives</p>
                                <div className="quest-milestones">
                                    <div className="milestone milestone--complete">✓</div>
                                    <div className="milestone milestone--complete">✓</div>
                                    <div className="milestone milestone--current">3</div>
                                    <div className="milestone">4</div>
                                    <div className="milestone">5</div>
                                </div>
                                <div className="quest-rewards">
                                    <span className="reward reward--special">🎁 LEGENDARY SKIN</span>
                                    <span className="reward">5,000 XP</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* RIGHT: Events & Activity */}
                <div className="panel panel--events">
                    {/* Pop-up Challenge Events */}
                    <div className="popup-events">
                        <h4 className="section-title">
                            POP-UP CHALLENGES
                            <span className="live-indicator">
                                <span className="live-dot" />
                                LIVE
                            </span>
                        </h4>
                        <div className="event-card event-card--popup">
                            <div className="event-timer">
                                <span className="timer-value">23:45</span>
                                <span className="timer-label">REMAINING</span>
                            </div>
                            <h5 className="event-title">MIDNIGHT MAYHEM</h5>
                            <p className="event-desc">Get 50 kills before midnight</p>
                            <div className="event-progress">
                                <span className="progress-current">32/50</span>
                                <div className="progress-bar">
                                    <div className="progress-fill" style={{width: "64%"}}>
                                        <div className="progress-glow" />
                                    </div>
                                </div>
                            </div>
                            <div className="event-reward">
                                <span className="reward-icon">💎</span>
                                <span className="reward-text">1,000 FUEL</span>
                            </div>
                        </div>
                    </div>

                    {/* Brand Challenges */}
                    <div className="brand-challenges">
                        <h4 className="section-title">BRAND CHALLENGES</h4>
                        <div className="brand-card">
                            <div className="brand-header">
                                <img src="https://via.placeholder.com/40" alt="Red Bull" className="brand-logo" />
                                <span className="brand-name">RED BULL</span>
                            </div>
                            <h5 className="challenge-title">WINGS OF VICTORY</h5>
                            <p className="challenge-desc">Win 5 matches with clutch plays</p>
                            <div className="challenge-games">
                                <span className="game-icon">🎯</span>
                                <span className="game-icon">⚡</span>
                                <span className="game-icon">🔫</span>
                            </div>
                            <div className="challenge-rewards">
                                <span className="reward">2,500 XP</span>
                                <span className="reward">🎁 EXCLUSIVE WINGS</span>
                            </div>
                            <button className="challenge-action">ENTER CHALLENGE</button>
                        </div>
                    </div>

                    {/* Activity Feed */}
                    <div className="activity-feed">
                        <h4 className="section-title">ACTIVITY FEED</h4>
                        <div className="feed-filters">
                            <button className="filter active">ALL</button>
                            <button className="filter">XP</button>
                            <button className="filter">REWARDS</button>
                            <button className="filter">FUEL</button>
                        </div>

                        <div className="feed-list">
                            <div className="feed-item feed-item--xp">
                                <span className="item-icon">⚡</span>
                                <div className="item-content">
                                    <span className="item-text">Earned <strong>750 XP</strong></span>
                                    <span className="item-time">2 min ago</span>
                                </div>
                            </div>

                            <div className="feed-item feed-item--reward">
                                <span className="item-icon">🎁</span>
                                <div className="item-content">
                                    <span className="item-text">Unlocked <strong>Rare Skin</strong></span>
                                    <span className="item-time">15 min ago</span>
                                </div>
                            </div>

                            <div className="feed-item feed-item--fuel">
                                <span className="item-icon">💎</span>
                                <div className="item-content">
                                    <span className="item-text">Received <strong>500 FUEL</strong></span>
                                    <span className="item-time">1 hour ago</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Happenings / Promo Cards */}
                    <div className="happenings">
                        <h4 className="section-title">HAPPENINGS</h4>
                        <div className="promo-card">
                            <div className="promo-image">
                                <img src="https://via.placeholder.com/280x120" alt="Promo" />
                                <div className="promo-badge">NEW</div>
                            </div>
                            <div className="promo-content">
                                <h5 className="promo-title">DOUBLE XP WEEKEND</h5>
                                <p className="promo-desc">All quests give 2X rewards</p>
                                <span className="promo-date">Nov 25-27</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GridCommandStructured;